import * as React from 'react';
import { IStackTokens, Stack } from '@fluentui/react/lib/Stack';
import { Dropdown, DropdownMenuItemType, IDropdownStyles, IDropdownOption } from '@fluentui/react/lib/Dropdown';

const dropdownStyles = {
    dropdown: { width: 300 },
};

const options = [
    { key: 'europeHeader', text: 'Europe', itemType: DropdownMenuItemType.Header },
    { key: '1', text: 'Albania' },
    { key: '2', text: 'Andorra' },
    { key: '3', text: 'Austria' },
    { key: '4', text: 'Belarus' },
    { key: '5', text: 'Belgium' },
    { key: '6', text: 'Bosnia and Herzegovina' },
    { key: '7', text: 'Croatia' },
    { key: '8', text: 'Czech Republic (Czechia)' },
    { key: '9', text: 'Denmark' },
    { key: '10', text: 'Estonia' },
    { key: '11', text: 'Finland' },
    { key: '12', text: 'France' },
    { key: '13', text: 'Germany' },
    { key: '14', text: 'Greece' },
    { key: '15', text: 'Holy See' },
    { key: '16', text: 'Hungary' },
    { key: '17', text: 'Iceland' },
    { key: '18', text: 'Ireland' },
    { key: '19', text: 'Italy' },
    { key: '20', text: 'Latvia' },
    { key: '21', text: 'Liechtenstein' },
    { key: '22', text: 'Lithuania' },
    { key: '23', text: 'Malta' },
    { key: '24', text: 'Moldova' },
    { key: '25', text: 'Monaco' },
    { key: '26', text: 'Montenegro' },
    { key: '27', text: 'Netherlands' },
    { key: '28', text: 'North Macedonia' },
    { key: '29', text: 'Norway' },
    { key: '30', text: 'Poland' },
    { key: '31', text: 'Romania' },
    { key: '32', text: 'Russia' },
    { key: '33', text: 'San Marino' },
    { key: '34', text: 'Serbia' },
    { key: '35', text: 'Slovakia' },
    { key: '36', text: 'Slovenia' },
    { key: '37', text: 'Spain' },
    { key: '38', text: 'Sweden' },
    { key: '39', text: 'Switzerland' },
    { key: '40', text: 'Ukraine' },
    { key: '41', text: 'United Kingdom' },
    { key: 'divider_1', text: '-', itemType: DropdownMenuItemType.Divider },
    { key: 'northAmerica', text: 'North America', itemType: DropdownMenuItemType.Header },
    { key: 'us', text: 'Antigua and Barbuda' },
    { key: 'cn', text: 'Bahamas' },
    { key: 'mcx', text: 'Belize' },
    { key: 'mcx', text: 'Canada' },
    { key: 'mcx', text: 'Costa Rica' },
    { key: 'mcx', text: 'Cuba' },
    { key: 'mcx', text: 'Dominica' },
    { key: 'mcx', text: 'Dominican Republic' },
    { key: 'mcx', text: 'El Salvador' },
    { key: 'mcx', text: 'Grenada' },
    { key: 'mcx', text: 'Guatemala' },
    { key: 'mcx', text: 'Haiti' },
    { key: 'mcx', text: 'Honduras' },
    { key: 'mcx', text: 'Jamaica' },
    { key: 'mcx', text: 'Mexico' },
    { key: 'mcx', text: 'Nicaragua' },
    { key: 'mcx', text: 'Panama' },
    { key: 'mcx', text: 'Saint Kitts and Nevis' },
    { key: 'mcx', text: 'Saint Lucia' },
    { key: 'mcx', text: 'Saint Vincent and the Grenadines' },
    { key: 'mcx', text: 'Trinidad and Tobago' },
    { key: 'mcx', text: 'United States' },
    { key: 'southAmerica', text: 'South America', itemType: DropdownMenuItemType.Header },
    { key: 'mcx', text: 'Argentina' },
    { key: 'mcx', text: 'Bolivia' },
    { key: 'mcx', text: 'Brazil' },
    { key: 'mcx', text: 'Chile' },
    { key: 'mcx', text: 'Colombia' },
    { key: 'mcx', text: 'Ecuador' },
    { key: 'mcx', text: 'Falkland Islands' },
    { key: 'mcx', text: 'French Guiana' },
    { key: 'mcx', text: 'Guyana' },
    { key: 'mcx', text: 'Paraguay' },
    { key: 'mcx', text: 'Peru' },
    { key: 'mcx', text: 'Suriname' },
    { key: 'mcx', text: 'Uruguay' },
    { key: 'mcx', text: 'Venezuela' },
    { key: 'asia', text: 'Asia', itemType: DropdownMenuItemType.Header },
    { key: 'mcx', text: 'Afghanistan' },
    { key: 'mcx', text: 'Armenia' },
    { key: 'mcx', text: 'Azerbaijan' },
    { key: 'mcx', text: 'Bahrain' },
    { key: 'mcx', text: 'Bangladesh' },
    { key: 'mcx', text: 'Bhutan' },
    { key: 'mcx', text: 'Brunei' },
    { key: 'mcx', text: 'Cambodia' },
    { key: 'mcx', text: 'China' },
    { key: 'mcx', text: 'Cyprus' },
    { key: 'mcx', text: 'Georgia' },
    { key: 'mcx', text: 'India' },
    { key: 'mcx', text: 'Indonesia' },
    { key: 'mcx', text: 'Iran' },
    { key: 'mcx', text: 'Iraq' },
    { key: 'mcx', text: 'Israel' },
    { key: 'mcx', text: 'Japan' },
    { key: 'mcx', text: 'Jordan' },
    { key: 'mcx', text: 'Kazakhstan' },
    { key: 'mcx', text: 'Kuwait' },
    { key: 'mcx', text: 'Kyrgyzstan' },
    { key: 'mcx', text: 'Laos' },
    { key: 'mcx', text: 'Lebanon' },
    { key: 'mcx', text: 'Malaysia' },
    { key: 'mcx', text: 'Maldives' },
    { key: 'mcx', text: 'Mongolia' },
    { key: 'mcx', text: 'Myanmar' },
    { key: 'mcx', text: 'Nepal' },
    { key: 'mcx', text: 'North Korea' },
    { key: 'mcx', text: 'Oman' },
    { key: 'mcx', text: 'Pakistan' },
    { key: 'mcx', text: 'Philippines' },
    { key: 'mcx', text: 'Qatar' },
    { key: 'mcx', text: 'Saudi Arabia' },
    { key: 'mcx', text: 'Singapore' },
    { key: 'mcx', text: 'South Korea' },
    { key: 'mcx', text: 'Sri Lanka' },
    { key: 'mcx', text: 'State of Palestine' },
    { key: 'mcx', text: 'Syria' },
    { key: 'mcx', text: 'Thailand' },
    { key: 'mcx', text: 'Timor-Leste' },
    { key: 'mcx', text: 'Turkey' },
    { key: 'mcx', text: 'Turkmenistan' },
    { key: 'mcx', text: 'United Arab Emirates' },
    { key: 'mcx', text: 'Uzbekistan' },
    { key: 'mcx', text: 'Vietnam' },
    { key: 'mcx', text: 'Yemen' },
];

const stackTokens = { childrenGap: 20 };

export const CountrySelectionDropdown = (props) => {
    const { setCountry } = props;

    const onChange = (event, item) => {
        setCountry(item.text);
      };

    return (
        <Stack tokens={stackTokens}>
            <Dropdown
                placeholder="Select Your Location"
                onChange={onChange}
                options={options}
                styles={dropdownStyles}
            />
        </Stack>
    );
};
